/* Intersection Observer (Web API) */

// Add CSS Class when element is in View Port
export function axIntersectionObserver(
	element,
	cssClassDynamic,
	toggleClass = false
) {
	const ax_elements = document.querySelectorAll( element );

	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if ( entry.intersectionRatio > 0 ) {
				entry.target.classList.add( cssClassDynamic );
				entry.target.classList.remove( 'no-js' );
			} else {
				if ( toggleClass ) {
					entry.target.classList.remove( cssClassDynamic );
				}
			}
		} );
	} );

	ax_elements.forEach( ( item ) => {
		observer.observe( item );
	} );
}
